import React from 'react'
import { array, string, bool } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { EMPTY_ARRAY, PROJECTS, PRODUCTS, NUMERAL, ALL } from '../../../utils/constants'
import { widgetMessages } from '../messages'
import WidgetRoundedImage from './WidgetRoundedImage'
import WidgetGridImages from './WidgetGridImages'

const WidgetContainer = ({
  data = EMPTY_ARRAY,
  widgetName = 'offices',
  searchType = '',
  query,
  viewAllLink = NUMERAL,
  isExpert,
  scope = 'us',
  withoutTitle,
  ...rest
}) => {
  const isCompanies = widgetName === 'companies'

  return (
    <div className={`widget-with-image widget-with-image--${widgetName} widget-with-image--in-${searchType}`} {...rest}>
      {searchType === ALL && isExpert
        ? null
        : (
          <div className='widget-with-image__header'>
            {!withoutTitle && <p><FormattedMessage {...widgetMessages[widgetName]} /></p>}
            {isCompanies && <a href={viewAllLink}><FormattedMessage {...widgetMessages.viewAll} /><p>»</p></a>}
          </div>
        )
      }
      <div className='widget-with-image__list'>
        {[PROJECTS, PRODUCTS].includes(searchType)
          ? <WidgetRoundedImage
            data={data}
            widgetName={widgetName}
            searchType={searchType}
            query={query}
            isExpert={isExpert}
            isCompanies
          />
          : <WidgetGridImages
            data={data}
            widgetName={widgetName}
            searchType={searchType}
            query={query}
            scope={scope}
          />
        }
      </div>
    </div>
  )
}

WidgetContainer.propTypes = {
  /**
   * Widget data
  */
  data: array,
  /**
   * Type of search
  */
  searchType: string,
  /**
   * Search query value
  */
  query: string,
  /**
   * Widget name
  */
  widgetName: string,
  /**
   * View All Link
  */
  viewAllLink: string,
  /**
   * Is Expert Widget
  */
  isExpert: bool,
  /**
   * Site
  */
  scope: string,
  /**
   * Strip title
  */
  withoutTitle: bool
}

export default WidgetContainer
